import React, { createContext, useContext, useEffect, useState } from 'react';

// queries
import { useGetReactionCommentsQuery } from 'queries/reactions/reactionsCommentsQuery';
import { usePostReactionCommentsMutation } from 'queries/reactions/postReactionCommentsMutation';
import { useDeleteReactionCommentsMutation } from 'queries/reactions/deleteReactionCommentsMutation';
// types
import { VideoReactionItem } from 'queries/reactions/types';
import { IReactionContext } from './types';
import { useIsFetching } from 'react-query';

export const ReactionContext = createContext({} as IReactionContext);
// THIS SHOULD BE MOVED AS A CHILD COMPONENT OF MAIN PROVIDER INSTEAD OF BEING A SEPARATE PROVIDER
export const ReactionProvider = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const isFetching = useIsFetching() > 0;

  const [visitorCode, setVisitorCode] = useState<string | null>(() =>
    localStorage?.getItem('visitorCode')
  );

  // re-read visitorCode once all queries settle
  // this catches the Safari case where ensureVisitorCode ran after this component mounted
  useEffect(() => {
    if (!isFetching && !visitorCode) {
      const code = localStorage?.getItem('visitorCode');
      setVisitorCode(code);
    }
  }, [isFetching]);

  const reactionsQuery = useGetReactionCommentsQuery(visitorCode);
  const addReactionMutation = usePostReactionCommentsMutation();
  const deleteReactionMutation = useDeleteReactionCommentsMutation();

  const addReaction = (data: Partial<VideoReactionItem>) => {
    addReactionMutation.mutate({ data });
  };

  const deleteReaction = (id: string | number) => {
    deleteReactionMutation.mutate({ id, data: { visitorCode } });
  };

  return (
    <ReactionContext.Provider
      value={{
        reactionsQuery,
        addReactionMutation,
        deleteReactionMutation,
        addReaction,
        deleteReaction,
      }}
    >
      {children}
    </ReactionContext.Provider>
  );
};

export const useReaction = () => {
  const context = useContext(ReactionContext);
  if (context === undefined) {
    throw new Error('useReaction must be used within a ReactionProvider');
  }
  return context;
};
